<template>
  <div>
    <!--面包屑导航区域-->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>硬件相关</el-breadcrumb-item>
      <el-breadcrumb-item>状态列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!--面包屑导航区域-->
    <!--卡片视图区-->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-select
              v-model="queryInfo.storeId"
              placeholder="请选择门店"
              @change="getList()"
              style="margin-left: 10px"
              clearable
              filterable
          >
            <el-option
                v-for="item in storelist"
                :key="item.id"
                :label="item.storename"
                :value="item.id"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select  v-model="queryInfo.status" clearable  placeholder="请选择状态" @change="getList()"  style="margin-right:10px">
            <el-option label="在线" value="O"></el-option>
            <el-option label="离线" value="N"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select  v-model="queryInfo.lx" clearable  placeholder="请选择类型" @change="getList()"  style="margin-right:10px">
            <el-option label="上位机" value="0"></el-option>
            <el-option label="上位机（二）" value="4"></el-option>
            <el-option label="大厅控制器" value="1"></el-option>
            <el-option label="淋浴控制器" value="2"></el-option>
            <el-option label="空调控制器" value="3"></el-option>
            <el-option label="第一门继电器" value="5"></el-option>
            <el-option label="第二门继电器" value="6"></el-option>
          </el-select>
        </el-col>
      </el-row>
      <br>
      <!--商品列表区域-->
      <el-table :data="list" style="width: 100%" v-loading="loading" stripe size="middle" border height="700">
        <el-table-column label="序号" width="50" fixed align="center">
            <template slot-scope="scope">
                {{ (queryInfo.page - 1) * queryInfo.limit + scope.$index + 1 }}
            </template>
        </el-table-column>
        <el-table-column label="门店名称" prop="storename" show-overflow-tooltip fixed align="center"/>
        <el-table-column label="硬件类型" width="130" align="center">
          <template slot-scope="{row}">
            <el-tag type="info" v-if="row.lx == '0'">上位机</el-tag>
            <el-tag type="info" v-else-if="row.lx == '4'">上位机（二）</el-tag>
            <el-tag type="primary" v-else-if="row.lx == '1'">大厅控制器</el-tag>
            <el-tag type="warning" v-else-if="row.lx == '2'">淋浴控制器</el-tag>
            <el-tag type="success" v-else-if="row.lx == '3'">空调控制器</el-tag>
            <el-tag type="danger" v-else-if="row.lx == '5'">第一门继电器</el-tag>
            <el-tag type="danger" v-else-if="row.lx == '6'">第二门继电器</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="{row}">
            <el-tag type="success" v-if="row.status == 'O'">在线</el-tag>
            <el-tag type="danger" v-else-if="row.status == 'N'">离线</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" prop="updateTimeStr" width="150" align="center"></el-table-column>
      </el-table>
      <!--商品列表区域-->
      <!--分页区域-->
      <br>
      <div align="center">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                       :current-page="queryInfo.page" :page-sizes="[20,50,500,1000]"  :page-size="queryInfo.limit"
                       layout="total, sizes, prev, pager, next" :total="total">
        </el-pagination>
      </div>
      <!--分页区域-->
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      total: 0,
      storelist: [],
      list: [],
      queryInfo: {
        page: 1,
        limit: 10,
        storeId: null,
        lx: null,
        status: null
      }
    }
  },
  created() {
    this.GetStore()

    this.getList()
    setInterval(() => {
      this.getList()
    }, 60000)
  },
  methods: {
    async getList() {
      this.loading = true
      const { data: res } = await this.$http.post("store-cls-question/hardwareList",  this.queryInfo);
      this.loading = false
      if (res.status == 0) {
        this.list = res.data.list;
        this.total = res.data.total;
      }
    },
    async GetStore() {
      const { data: res } = await this.$http.get("store/");
      if (res.status == 0) {
        this.storelist = res.data;
      }
    },
    handleSizeChange(newSize){
      this.queryInfo.limit = newSize
      this.getList()
    },
    handleCurrentChange(newPage){
      this.queryInfo.page = newPage
      this.getList()
    },
  }
}
</script>

<style scoped>

</style>
